import {type Epic, ofType} from 'redux-observable';
import {of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import i18next from 'i18next';

import {type RootState} from 'web-app/react/redux/main-reducer';
import {combineEpics} from 'web-app/util/redux-observable';
import {type InferAction} from 'web-app/util/redux/typed-action-helpers';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Actions from './actions';
import * as API from './typed-api';

const leaveConversation: Epic<InferAction<typeof Actions['leaveConversation']>, any, RootState, {}> = action$ =>
    action$.pipe(
        ofType(Actions.leaveConversation.type),
        mergeMap(action =>
            API.leaveConversation(action.payload.conversationId).pipe(
                mergeMap(response => [
                    Actions.leaveConversationSuccess.action(response.conversationId),
                    GlobalEventActions.updateSuccess.action(
                        i18next.t('reportUserGeneratedContent.messages.leftConversation'),
                    ),
                ]),
            ),
        ),
        catchError(e => of(Actions.leaveConversationFailed.action(e))),
    );

export default combineEpics(leaveConversation);
